import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    labelClassName,
    checkboxClassName,
} from '@archipro-design/aria';

export const CategoryFilters: StyleRule = ({ theme }) => ({
    gridGap: pxToRem(24),
    [theme.screen.laptop]: {
        gridGap: pxToRem(16),
    },
});

export const CategoryFilter: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        [`&.${checkboxClassName}`]: {
            [`& .${labelClassName}`]: {
                fontSize: pxToRem(30),
                lineHeight: pxToRem(30),
                letterSpacing: '-0.01em',
                [`&:hover`]: {
                    textDecoration: 'underline',
                    color: theme.siteVariables.colors.primitive.black,
                },
            },
        },
    },
});

export const Active: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        textDecoration: 'underline',
        textUnderlineOffset: pxToRem(2),
    },
});
